// Generated from SEO Wikidata city mapping (MP-22717). Keys are city slugs as used in LRP URLs.
// Source: 'Wikidata Brand Mapping - sameAs structured data' (tab: steden).
// Do not add entries by guessing Wikidata IDs — only verified IDs from the SEO mapping table.

export const WIKIDATA_CITY_SAMEAS: Readonly<Record<string, string>> = {
  amsterdam: 'https://www.wikidata.org/wiki/Q727',
  rotterdam: 'https://www.wikidata.org/wiki/Q34370',
  'den-haag': 'https://www.wikidata.org/wiki/Q36600',
  'den+haag': 'https://www.wikidata.org/wiki/Q36600',
  utrecht: 'https://www.wikidata.org/wiki/Q803',
  eindhoven: 'https://www.wikidata.org/wiki/Q9832',
  groningen: 'https://www.wikidata.org/wiki/Q749',
  tilburg: 'https://www.wikidata.org/wiki/Q9871',
  almere: 'https://www.wikidata.org/wiki/Q83178',
  breda: 'https://www.wikidata.org/wiki/Q40844',
  nijmegen: 'https://www.wikidata.org/wiki/Q47887',
  haarlem: 'https://www.wikidata.org/wiki/Q9920',
  arnhem: 'https://www.wikidata.org/wiki/Q1310',
  enschede: 'https://www.wikidata.org/wiki/Q10002',
  amersfoort: 'https://www.wikidata.org/wiki/Q992',
  apeldoorn: 'https://www.wikidata.org/wiki/Q101918',
  's-hertogenbosch': 'https://www.wikidata.org/wiki/Q2766547',
  maastricht: 'https://www.wikidata.org/wiki/Q1309',
  leiden: 'https://www.wikidata.org/wiki/Q43631',
  dordrecht: 'https://www.wikidata.org/wiki/Q26421',
  zoetermeer: 'https://www.wikidata.org/wiki/Q26432',
  zwolle: 'https://www.wikidata.org/wiki/Q793',
  delft: 'https://www.wikidata.org/wiki/Q690',
  alkmaar: 'https://www.wikidata.org/wiki/Q972',
  leeuwarden: 'https://www.wikidata.org/wiki/Q25390',
  hilversum: 'https://www.wikidata.org/wiki/Q9934',
  deventer: 'https://www.wikidata.org/wiki/Q10001',
  venlo: 'https://www.wikidata.org/wiki/Q9777',
  emmen: 'https://www.wikidata.org/wiki/Q14641',
  assen: 'https://www.wikidata.org/wiki/Q798',
  gouda: 'https://www.wikidata.org/wiki/Q84125',
  lelystad: 'https://www.wikidata.org/wiki/Q166065',
  zaandam: 'https://www.wikidata.org/wiki/Q211260',
  middelburg: 'https://www.wikidata.org/wiki/Q52101',
  helmond: 'https://www.wikidata.org/wiki/Q9844',
  hengelo: 'https://www.wikidata.org/wiki/Q10006',
  ede: 'https://www.wikidata.org/wiki/Q26555',
  'alphen-aan-den-rijn': 'https://www.wikidata.org/wiki/Q213246',
  purmerend: 'https://www.wikidata.org/wiki/Q9954',
  roosendaal: 'https://www.wikidata.org/wiki/Q9861',
  schiedam: 'https://www.wikidata.org/wiki/Q204709',
  hoorn: 'https://www.wikidata.org/wiki/Q9938',
  heerlen: 'https://www.wikidata.org/wiki/Q9799',
  'bergen-op-zoom': 'https://www.wikidata.org/wiki/Q192508',
  veenendaal: 'https://www.wikidata.org/wiki/Q1840',
  spijkenisse: 'https://www.wikidata.org/wiki/Q488545',
  roermond: 'https://www.wikidata.org/wiki/Q9783',
  vlaardingen: 'https://www.wikidata.org/wiki/Q210007',
  'sittard-geleen': 'https://www.wikidata.org/wiki/Q9781',
  kampen: 'https://www.wikidata.org/wiki/Q10014',
  hoogeveen: 'https://www.wikidata.org/wiki/Q208012',
};
